import { NavLink, useLocation } from "react-router-dom";

const CustomerManagementSidebar = () => {
  const location = useLocation();
  return (
    <div
      className={`menu-item has-sub ${location.pathname.startsWith("/customer") ? "active" : ""
        }`}
    >
      <div className="menu-link">
        <div className="menu-icon">
          <i className="fa-solid fa-users-line"></i>
        </div>
        <div className="menu-text">Customers</div>
        <div className="menu-caret"></div>
      </div>
      <div className="menu-submenu">
        <div
          className={`menu-item ${location.pathname.startsWith("/customer/") ? "active" : ""}`}
        >
          <NavLink to="/customer/manageCustomer" className="menu-link">
            Customers
          </NavLink>
        </div>

        <div
          className={`menu-item ${location.pathname.startsWith("/customerGroup/") ? "active" : ""
            }`}
        >
          <NavLink to="/customerGroup/manageCustomerGroup" className="menu-link">
            Customer Groups
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default CustomerManagementSidebar;